module.exports = __webpack_public_path__ + "static/media/list2White.4371893d.svg";